import { render, staticRenderFns } from "./WhatsNewSection.vue?vue&type=template&id=ce6300f6&scoped=true"
import script from "./WhatsNewSection.vue?vue&type=script&lang=js"
export * from "./WhatsNewSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6300f6",
  null
  
)

export default component.exports